import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "68",
  height: "68",
  viewBox: "0 0 68 68",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "34",
  cy: "34",
  r: "34",
  fill: "#F3F3F3"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "34",
  cy: "23",
  r: "12",
  fill: "#DCD6D4"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.29492 53.7129C12.6553 45.3691 22.6991 39.9844 34.0005 39.9844C45.3019 39.9844 55.3457 45.3691 61.7061 53.7129C55.542 62.3609 45.4298 68.0004 34.0005 68.0004C22.5712 68.0004 12.4591 62.3609 6.29492 53.7129Z",
  fill: "#DCD6D4"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }